import React from 'react';
import { Redirect } from 'react-router-dom';
import { url } from './App/urls';

const RedirectToProjects = () => <Redirect to={url.projectList()} />;

export default RedirectToProjects;
